 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		3: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"a9a7754c","1":"commons","2":"styles","4":"012a6e4f","5":"2e12fdb9","6":"35696763","7":"4f67e545","8":"5a708cbe","9":"8237aa26","10":"9167340b","11":"a9ad3ca1","13":"b8c52184","14":"bc58d897","15":"cb0fce4c","16":"component---src-pages-404-js","17":"component---src-pages-about-js","18":"component---src-pages-advanced-statistics-modelling-scenarios-js","19":"component---src-pages-advanced-statistics-risk-analysis-js","20":"component---src-pages-advanced-statistics-statistical-tests-js","21":"component---src-pages-europe-conclusion-js","22":"component---src-pages-europe-first-wave-js","23":"component---src-pages-europe-general-findings-js","24":"component---src-pages-europe-measures-js","25":"component---src-pages-europe-second-wave-js","26":"component---src-pages-europe-summer-period-js","27":"component---src-pages-europe-vaccination-js","28":"component---src-pages-get-in-touch-js","29":"component---src-pages-global-analysis-js","30":"component---src-pages-greece-a-quick-comparison-js","31":"component---src-pages-greece-conclusion-js","32":"component---src-pages-greece-demographics-js","33":"component---src-pages-greece-general-findings-js","34":"component---src-pages-greece-health-facilities-deaths-js","35":"component---src-pages-greece-measures-mobility-js","36":"component---src-pages-greece-success-during-the-first-wave-js","37":"component---src-pages-greece-vaccination-effect-js","38":"component---src-pages-index-js","39":"component---src-pages-latin-america-conclusion-js","40":"component---src-pages-latin-america-general-findings-js","41":"component---src-pages-latin-america-socio-economic-and-healts-factors-js","42":"component---src-pages-privacy-policy-js","43":"component---src-pages-technology-js","44":"component---src-pages-terms-js","45":"e5437d3c"}[chunkId]||chunkId) + "-" + {"0":"63b04cd4b8a8619ce68d","1":"e095e212a51ecfc4a1a0","2":"7d4153d260c0197f0043","4":"e10ee0c702453a1b0cdb","5":"cee1ebee57b89e5f72b3","6":"b8ccbb491274be1e194f","7":"4357688016f0de0aaa76","8":"6043a161d4432bf54014","9":"284496692a73b270d6d9","10":"1d692d7876f477104714","11":"1a77d86866ff5cbd6f9d","13":"f680f3077c73a4781b78","14":"035e0052027cb65dfb6b","15":"1203415f045506fa9c77","16":"2224373bdffc5d001023","17":"1dcd563a791abc7c07ff","18":"28432d7c4eb90a95540f","19":"cf7856470050ed383f5e","20":"04525b79b68d0c988beb","21":"c411e6258e79b1c069ff","22":"dd80adee6a8f2668e52c","23":"4e66490734a12dd4676e","24":"4814161364fe16fb1be9","25":"4a00d501810c14ea8b6c","26":"cc75d89b42f958897118","27":"88611cac3b5633a2235b","28":"57e0370787e8e0912ab0","29":"3b1be36bfd22c40c3ba5","30":"d84d90646a5ad56da097","31":"91f83b4d2d2587aaf0b7","32":"cfee686a65129db4a917","33":"8e430886919bb3af8a29","34":"faba1053fd33c77933b3","35":"c9c04077cb81ba4816a8","36":"91ebeebfa9559e94d987","37":"d003b27f1706b0f2c1df","38":"ebe66589aecbd55ce4d4","39":"5a10ceb5cde39fdc9e27","40":"ed1275bf3a78f72c2002","41":"09ffd1fc5a90f5569d3c","42":"12d4a15beb0f7bbd401f","43":"4cbcb17963d3b177f413","44":"efa9089e31f8b7f3d93b","45":"da6a6783421b125f6762"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"a9a7754c","1":"commons","2":"styles","4":"012a6e4f","5":"2e12fdb9","6":"35696763","7":"4f67e545","8":"5a708cbe","9":"8237aa26","10":"9167340b","11":"a9ad3ca1","13":"b8c52184","14":"bc58d897","15":"cb0fce4c","16":"component---src-pages-404-js","17":"component---src-pages-about-js","18":"component---src-pages-advanced-statistics-modelling-scenarios-js","19":"component---src-pages-advanced-statistics-risk-analysis-js","20":"component---src-pages-advanced-statistics-statistical-tests-js","21":"component---src-pages-europe-conclusion-js","22":"component---src-pages-europe-first-wave-js","23":"component---src-pages-europe-general-findings-js","24":"component---src-pages-europe-measures-js","25":"component---src-pages-europe-second-wave-js","26":"component---src-pages-europe-summer-period-js","27":"component---src-pages-europe-vaccination-js","28":"component---src-pages-get-in-touch-js","29":"component---src-pages-global-analysis-js","30":"component---src-pages-greece-a-quick-comparison-js","31":"component---src-pages-greece-conclusion-js","32":"component---src-pages-greece-demographics-js","33":"component---src-pages-greece-general-findings-js","34":"component---src-pages-greece-health-facilities-deaths-js","35":"component---src-pages-greece-measures-mobility-js","36":"component---src-pages-greece-success-during-the-first-wave-js","37":"component---src-pages-greece-vaccination-effect-js","38":"component---src-pages-index-js","39":"component---src-pages-latin-america-conclusion-js","40":"component---src-pages-latin-america-general-findings-js","41":"component---src-pages-latin-america-socio-economic-and-healts-factors-js","42":"component---src-pages-privacy-policy-js","43":"component---src-pages-technology-js","44":"component---src-pages-terms-js","45":"e5437d3c"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"ff6525cc0992653488e0","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
